import {
  Grid,
  InputAdornment,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import globalClasses from "../../commoncomponents/css/Global.module.css";
import { useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import ViewPlansHome from "../../viewplans/ViewPlansHome";
import { useDispatch, useSelector } from "react-redux";
import { getRequest, singoutHandler } from "../../../api/AxiosAPICall";
import { setSnackbar } from "../../commoncomponents/alert/SnackbarAction";
import CommonLayout from "../../commoncomponents/layout/CommonLayout";
import moment from "moment";
import {
  setPaymentInformation,
  setPaymentStatus,
  setSubscriptionDate,
  setSubscriptionSortedDate,
} from "../RegistraionAction";
import { useNavigate } from "react-router-dom";

let copiedPaymentData: any;
let sortedDate: any[] = [];
const PaymentHistory = (props: any) => {
  let history = useNavigate();
  const [paymentData, setPaymentData] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [searched, setSearched] = useState("");
  let jwtToken: any;
  const isMounted = useRef<any>(false);
  const { paymentStatus } = useSelector((state: any) => state.payment);

  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }

  const dispatch = useDispatch();
  if (paymentStatus === "paid") {
    dispatch(
      setSnackbar(
        true,
        undefined,
        "success",
        "Your PREMIUM subscription has been updated successfully !",
        "top",
        "center"
      )
    );
    dispatch(setPaymentStatus(""));
  } else if (paymentStatus === "failed") {
    dispatch(
      setSnackbar(true, null, "warning", "Payment failed!", "top", "center")
    );
    dispatch(setPaymentStatus(""));
  } else if (paymentStatus === "free") {
    dispatch(
      setSnackbar(
        true,
        undefined,
        "success",
        "Your FREE subscription has been updated successfully!",
        "top",
        "center"
      )
    );
    dispatch(setPaymentStatus(""));
  }

  const fetchTransactions = async () => {
    setSearched("");

    try {
      const response = await getRequest("paymentTransactionDetails", {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });

      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
        singoutHandler(jwtToken);
        localStorage.removeItem("token");
        history("/signin");
      } else {
        setPaymentData(response?.data);

        dispatch(setPaymentInformation(response?.data[0]?.ptpStatus));
        dispatch(
          setSubscriptionDate(response?.data[0]?.ptpSubscriptionEndDate)
        );
        copiedPaymentData = Object.assign([], response?.data);
        sortedDate = copiedPaymentData
          ?.sort(
            (
              a: {
                ptpSubscriptionEndDate: any;
              },
              b: {
                ptpSubscriptionEndDate: any;
              }
            ) => {
              return (
                a?.ptpSubscriptionEndDate !== undefined &&
                new Date(a?.ptpSubscriptionEndDate).getTime() -
                  new Date(b?.ptpSubscriptionEndDate).getTime()
              );
            }
          )
          .reverse();

        if (sortedDate[0]?.ptpSubscriptionEndDate !== undefined) {
          dispatch(
            setSubscriptionSortedDate(sortedDate[0].ptpSubscriptionEndDate)
          );

          localStorage.setItem(
            "subscriptionDate",
            sortedDate[0].ptpSubscriptionEndDate
          );
        }
        copiedPaymentData = [];
        sortedDate = [""];
      }
    } catch (err: any) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "User has already logged out!",
          "top",
          "center"
        )
      );
      history("/signin");
    }

    // eslint-disable-next-line
  };

  useEffect(() => {
    isMounted.current = true;
    fetchTransactions();

    return () => {
      isMounted.current = false;
      dispatch(setSubscriptionSortedDate(""));
      setPaymentData([]);
      setSearched("");
    };
    // eslint-disable-next-line
  }, [paymentStatus]);

  useEffect(() => {
    setTransactions(paymentData);
  }, [paymentData]);

  const requestSearch = (searchedVal: any) => {
    const filteredRows = paymentData?.filter((row: any) => {
      return row?.ptpTransactionIdentifier?.includes(searchedVal);
    });
    setTransactions(filteredRows);
  };

  return (
    <CommonLayout
      footer={true}
      hidePermium={false}
      showHeaderNavigation={true}
      isLogedIn={true}
    >
      {!props.isRenew && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Typography variant="h6" className={globalClasses.typography}>
              Payment History
            </Typography>
          </Grid>

          <Grid item xs={12} md={4} sx={styles.searchInput}>
            <TextField
              size="small"
              fullWidth
              label="Search with transaction ID"
              value={searched}
              onChange={(e: any) => {
                requestSearch(e.target.value);
                setSearched(e.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Paper>
              <TableContainer sx={{ maxHeight: "310px" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow
                      sx={{
                        "& .MuiTableCell-head": {
                          backgroundColor: "lightgray",
                          fontWeight: "600",
                        },
                      }}
                    >
                      <TableCell>Transaction ID</TableCell>
                      <TableCell align="center">Amount</TableCell>
                      <TableCell align="center">Billing Date</TableCell>
                      <TableCell align="center">
                        Subscription End Date
                      </TableCell>
                      <TableCell align="center">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {transactions?.length !== 0 ? (
                      transactions?.map((row: any) => (
                        <TableRow key={row.ptpTransactionIdentifier}>
                          <TableCell component="th" scope="row">
                            {row.ptpTransactionIdentifier}
                          </TableCell>

                          <TableCell align="center">
                            TT${row.ptpBillingAmount}
                          </TableCell>

                          <TableCell align="center">
                            {moment(row.ptpBillingDate).format("DD/MM/YYYY")}
                          </TableCell>

                          <TableCell align="center">
                            {row.ptpSubscriptionEndDate === null
                              ? ""
                              : moment(row.ptpSubscriptionEndDate).format(
                                  "DD/MM/YYYY"
                                )}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              color:
                                row.ptpStatus === "failed"
                                  ? "#E60000"
                                  : "green",
                            }}
                          >
                            {row.ptpStatus
                              .toString()
                              .substring(0, 1)
                              .toUpperCase() +
                              row.ptpStatus.toString().substring(1)}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={7}>
                          <Typography component="div" align="center">
                            No records found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
          <Grid item xs={12} md={12} margin="10px">
            <Link
              onClick={() => {
                props?.handleMakePayment();
              }}
            >
              Make Payment
            </Link>
          </Grid>
        </Grid>
      )}

      {props?.isRenew && (
        <ViewPlansHome
          ShowPaymentHistory={() => {
            props?.handleShowPaymentHistory();
          }}
        />
      )}
    </CommonLayout>
  );
};

export default PaymentHistory;

const styles = {
  searchInput: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
};
